import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import Marquee from 'react-fast-marquee';

const Footer = () => {
  return (
    <footer data-testid="footer">
      {/* Marquee */}
      <div className="bg-gradient-to-r from-[#FDF8F6] via-[#F5ECEA] to-[#FDF8F6] py-4">
        <Marquee speed={50} gradient={false}>
          <span className="mx-8 text-sm tracking-[0.2em] uppercase text-[#C4A484]">
            Cruelty Free
          </span>
          <span className="mx-8 text-sm text-[#D4A5A5]">✦</span>
          <span className="mx-8 text-sm tracking-[0.2em] uppercase text-[#C4A484]">
            Luxury Beauty
          </span>
          <span className="mx-8 text-sm text-[#D4A5A5]">✦</span>
          <span className="mx-8 text-sm tracking-[0.2em] uppercase text-[#C4A484]">
            Premium Quality
          </span>
          <span className="mx-8 text-sm text-[#D4A5A5]">✦</span>
          <span className="mx-8 text-sm tracking-[0.2em] uppercase text-[#C4A484]">
            Made for You
          </span>
          <span className="mx-8 text-sm text-[#D4A5A5]">✦</span>
          <span className="mx-8 text-sm tracking-[0.2em] uppercase text-[#C4A484]">
            CDMX Delivery
          </span>
          <span className="mx-8 text-sm text-[#D4A5A5]">✦</span>
        </Marquee>
      </div>

      {/* Main Footer */}
      <div className="bg-gradient-to-b from-[#1C1917] to-[#0F0D0C] text-white">
        <div className="container-luxury py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
            {/* Brand Section */}
            <div className="md:col-span-5">
              <div className="flex items-center mb-6">
                <img 
                  src="/aliglam-logo.png" 
                  alt="Aliglam" 
                  className="h-16 w-auto object-contain filter brightness-0 invert"
                  data-testid="footer-logo"
                />
              </div>
              <p className="text-[#A8A29E] text-sm leading-relaxed max-w-sm mb-8">
                Tu destino de belleza premium. Descubre productos de maquillaje y fragancias 
                de la más alta calidad, seleccionados especialmente para realzar tu belleza natural.
              </p>
              
              {/* Instagram - Elegant Style */}
              <a 
                href="https://www.instagram.com/aliglamshop/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-3 group"
                data-testid="social-instagram"
              >
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#D4A5A5] via-[#BA7B7C] to-[#C4A484] flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-[#BA7B7C]/20">
                  <Instagram className="w-5 h-5 text-white" strokeWidth={1.5} />
                </div>
                <span className="text-sm text-[#A8A29E] group-hover:text-white transition-colors tracking-wide">
                  @aliglamshop
                </span>
              </a>
            </div>

            {/* Spacer */}
            <div className="hidden md:block md:col-span-1"></div>

            {/* Shop Links */}
            <div className="md:col-span-3">
              <h3 className="text-xs tracking-[0.25em] uppercase mb-6 text-[#C4A484] font-medium">Tienda</h3>
              <ul className="space-y-4">
                <li>
                  <Link to="/shop" className="text-[#A8A29E] hover:text-[#D4A5A5] transition-colors text-sm hover:translate-x-1 inline-block transform duration-300">
                    Todos los productos
                  </Link>
                </li>
                <li>
                  <Link to="/shop?category=Perfumes" className="text-[#A8A29E] hover:text-[#D4A5A5] transition-colors text-sm hover:translate-x-1 inline-block transform duration-300">
                    Perfumes
                  </Link>
                </li>
                <li>
                  <Link to="/shop?category=Rubores" className="text-[#A8A29E] hover:text-[#D4A5A5] transition-colors text-sm hover:translate-x-1 inline-block transform duration-300">
                    Rubores
                  </Link>
                </li>
                <li>
                  <Link to="/shop?category=Primer" className="text-[#A8A29E] hover:text-[#D4A5A5] transition-colors text-sm hover:translate-x-1 inline-block transform duration-300">
                    Primer
                  </Link>
                </li>
                <li>
                  <Link to="/shop?category=Polvos compactos" className="text-[#A8A29E] hover:text-[#D4A5A5] transition-colors text-sm hover:translate-x-1 inline-block transform duration-300">
                    Polvos compactos
                  </Link>
                </li>
              </ul>
            </div>

            {/* Help Links */}
            <div className="md:col-span-3">
              <h3 className="text-xs tracking-[0.25em] uppercase mb-6 text-[#C4A484] font-medium">Ayuda</h3>
              <ul className="space-y-4">
                <li>
                  <a href="https://www.instagram.com/aliglamshop/" target="_blank" rel="noopener noreferrer" className="text-[#A8A29E] hover:text-[#D4A5A5] transition-colors text-sm hover:translate-x-1 inline-block transform duration-300">
                    Contacto
                  </a>
                </li>
                <li>
                  <span className="text-[#A8A29E] text-sm">
                    Envíos en CDMX
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Divider with gradient */}
          <div className="my-12 h-px bg-gradient-to-r from-transparent via-[#BA7B7C]/30 to-transparent"></div>

          {/* Bottom */}
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-2 mb-4 md:mb-0">
              <span className="text-[#C4A484] text-lg" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Aliglam
              </span>
              <span className="text-[#A8A29E] text-xs">Beauty & Style</span>
            </div>
            <p className="text-[#57534E] text-xs tracking-wide">
              © {new Date().getFullYear()} Aliglam. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
